import { useEffect, useState } from 'react';
import { disablePush, enablePush, getPushState, type PushState } from '../lib/push';

const HINT: Partial<Record<PushState, string>> = {
  unsupported: 'Dieses Gerät bzw. dieser Browser unterstützt keine Push-Benachrichtigungen. Auf iPhones muss die App dafür zum Home-Bildschirm hinzugefügt werden.',
  unconfigured: 'Push-Benachrichtigungen sind auf dem Server nicht verfügbar.',
  denied: 'Benachrichtigungen sind im Browser blockiert. Bitte in den Browser-/Systemeinstellungen für diese App erlauben.',
};

// Schaltet Push-Benachrichtigungen für dieses Gerät (installierte PWA) ein/aus.
export function PushToggle() {
  const [state, setState] = useState<PushState | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushState().then(setState).catch(() => setState('unsupported'));
  }, []);

  async function toggle() {
    setBusy(true);
    try {
      setState(state === 'on' ? await disablePush() : await enablePush());
    } catch {
      setState(await getPushState().catch(() => 'unsupported' as const));
    } finally {
      setBusy(false);
    }
  }

  if (!state) return null;
  const canToggle = state === 'on' || state === 'off';
  return (
    <div className="stack">
      <div className="row between">
        <span>Push-Benachrichtigungen auf diesem Gerät</span>
        <button onClick={toggle} disabled={busy || !canToggle} aria-pressed={state === 'on'}>
          {state === 'on' ? 'Ausschalten' : 'Einschalten'}
        </button>
      </div>
      {HINT[state] && <p className="muted">{HINT[state]}</p>}
    </div>
  );
}
